import {useIntl} from '@/react-intl';
import {AlertBanner} from '@/design-system/ds-0/components/AlertBanner';
import type {StudioCommand} from './commandCatalog';
import {designErrorMessage} from '../specs/specI18n';

/** The catalogue, version plans and Copilot share the same availability explanation. */
export default function CommandUnavailable({command}:{command:StudioCommand}){
 const intl=useIntl(),t=(id:string)=>intl.formatMessage({id});
 if(command.available)return null;
 const permission=command.reason==='moduleStudio.command.requires.permission';
 const title=permission?designErrorMessage(t,{code:'studio.permission.required',status:403,message:null,permission:command.entity+'.'+command.permission,action:t(command.labelId)}):t(command.reason||'moduleStudio.command.requires.state');
 const action=permission?'permission':/imports?|prototype/.test(command.reason)?'import':/orphan|regression/.test(command.reason)?'orphans':null;
 return <AlertBanner variant="warning" title={title} description={action?t('moduleStudio.command.reason.unlock.'+action):undefined}/>;
}
